import { Component } from 'react';
import {history} from '../../../../store';
import IgniteDataTable from '../../../common/datatable';

class PointsTypeList extends Component {
  state = {
    delete: {
      show: false
    }
  };

  render() {
    const columns = [
      {
        prop: 'name',
        title: 'Points Type',
      },
      {
        prop: 'link',
        title: 'Icon',
        format(data) {
          if (data && data.icon) {
            return (<img src={data.icon} alt="icon" style={ { maxWidth: '100px', height: 'auto' } } />);
          }
          return null;
        }
      }
    ];

    const actions = [
      {
        label: 'Edit',
        color: 'grey',
        permissions: {
          action: 'index',
          subjectClass: 'ManagePoints'
        },
        callback: (row) => {
          history.push(`/admin/points-types/${row.id}`);
        }
      },
    ];

    return (
      <div>
        <IgniteDataTable
          actions={actions}
          columns={columns}
          data={this.props.pointsTypes}
        />
      </div>
    );
  }
}

export default PointsTypeList;
